
const map = {
  'RUB': "₽",
}

export function beautifyCurrency(currency) {
  return map[currency] ? map[currency] : currency
}
